export function generateExportName(
  name?: string | null,
  separator: string = '_'
): string {
  if (!name) return '';

  const randomFourDigitNumber = Math.floor(
    1000 + Math.random() * 9000
  ).toString();
  return `${name}${separator}${randomFourDigitNumber}`;
}
